// extracted by mini-css-extract-plugin
module.exports = {"cls1":"Headlines-H4-module--cls1--3XF6I","cls2":"Headlines-H4-module--cls2--1Mrqz Headlines-H4-module--cls1--3XF6I"};